import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-compleanno-page',
  templateUrl: './compleanno-page.component.html',
  styleUrls: ['./compleanno-page.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class CompleannoPageComponent implements OnInit {
  showReward: boolean = false;
  constructor() {}

  ngOnInit(): void {}
}
